import { useState } from 'react'

import { validateEmail } from '@/helpers'

type Errors = {
    name?: string
    phone?: string
    company?: string
    email?: string
    message?: string
    submit?: string
}

type UseRateCardFormState = {
    name: string
    phone: string
    company: string
    email: string
    message: string
    submitting: boolean
    success: boolean
    errors: Errors
}

type UseRateCardForm = {
    formState: UseRateCardFormState
    onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    displayError: (fieldName: string, message: string) => void
    displayErrors: (errors: Errors) => void
    validate: () => boolean
    resetErrors: () => void
    changeSubmittingStatus: () => void
    setSuccessfulStatus: () => void
}

const useRateCardForm = (): UseRateCardForm => {

    const [formState, changeFormState] = useState({
        name: '',
        phone: '',
        company: '',
        email: '',
        message: '',
        submitting: false,
        success: false,
        errors: {
            name: '',
            phone: '',
            company: '',
            email: '',
            message: '',
            submit: '',
        },
    })

    function onInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        changeFormState((prevState) => ({
            ...prevState,
            [event?.target.name]: event?.target.value,
            errors: {
                ...prevState.errors,
                [event?.target.name]: '',
            },
        }))
    }

    function displayError(fieldName: string, message: string) {
        changeFormState((prevState) => ({
            ...prevState,
            errors: {
                ...prevState.errors,
                [fieldName]: message,
            },
        }))
    }

    function displayErrors(errors: Errors) {
        changeFormState((prevState) => ({
            ...prevState,
            errors: {
                ...prevState.errors,
                ...errors,
            },
        }))
    }

    function resetErrors() {
        changeFormState((prevState) => ({
            ...prevState,
            errors: {
                name: '',
                phone: '',
                company: '',
                email: '',
                message: '',
                submit: '',
            },
        }))
    }

    function changeSubmittingStatus() {
        changeFormState((prevState) => ({
            ...prevState,
            submitting: !prevState.submitting,
        }))
    }

    function setSuccessfulStatus() {
        changeFormState((prevState) => ({
            ...prevState,
            success: true,
        }))
    }

    function validate() {
        const { name, phone, company, email, message } = formState
        const errors: Errors = {
            name: '',
            phone: '',
            company: '',
            email: '',
            message: '',
        }
        let isValid = true

        if (!name.length) {
            errors.name = 'Please provide provide a name'
            isValid = false
        }

        if (!validateEmail(email)) {
            errors.email = 'Please provide valid Email Address'
            isValid = false
        }

        displayErrors(errors)

        return isValid
    }

    return {
        formState,
        onInputChange,
        displayError,
        displayErrors,
        resetErrors,
        changeSubmittingStatus,
        setSuccessfulStatus,
        validate,
    }
}

export default useRateCardForm
